import { Button, Spinner } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Global.css';
import Navbar from '../components/Navbar';
import { useNavigate } from "react-router-dom";
import { useEffect, useState, useRef, useCallback } from 'react';
import api from '../api';

function AllTournaments() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false); // Yeni veriler yüklenirkenki spinner
  const [page, setPage] = useState(1); // Sayfa numarası
  const [hasMore, setHasMore] = useState(true); // Yüklenecek başka veri kaldı mı?
  
  const navigate = useNavigate();
  const token = localStorage.getItem('JWTTOKEN');
  
  const observer = useRef();

  // Son elemanı izleyen Intersection Observer
  const lastElementRef = useCallback(node => {
    if (loading || loadingMore) return;
    if (observer.current) observer.current.disconnect();
    
    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && hasMore) {
        setPage(prevPage => prevPage + 1); // Sayfanın sonuna gelince sayfa numarasını artır
      }
    });
    
    if (node) observer.current.observe(node);
  }, [loading, loadingMore, hasMore]);

  const getData = async (currentPage) => {
    try {
      if (currentPage === 1) setLoading(true);
      else setLoadingMore(true);

      // Backend'e page ve limit gönderiyoruz
      const res = await api.get("/v1/tournament/all", {
        headers: { Authorization: `Bearer ${token}` },
        params: { page: currentPage, limit: 15 } // API'nin sayfalama desteklediğini varsayıyoruz
      });
      
      const newData = res.data.data;
      
      if (currentPage === 1) {
        setData(newData);
      } else {
        setData(prevData => [...prevData, ...newData]); // Eski verilerin üstüne yenilerini ekle
      }

      // Gelen veri limiti doldurmuyorsa daha fazla veri yoktur
      if (newData.length === 0 || newData.length < 15) {
        setHasMore(false);
      }
      
    } catch (err) {
      console.error("Veri çekme hatası:", err);
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };

  useEffect(() => {
    if (!token) {
      navigate("/login");
      return;
    }
    getData(page);
  }, [navigate, token, page]);

  const handleTournamentClick = (id) => {
    navigate(`/detail/${id}`);
  };

  return (
    <div className="app-container d-flex" style={{ backgroundColor: '#0a0a0a', minHeight: '100vh' }}>
      {/* Sol Menü */}
      <Navbar />

      {/* Sağ Ana İçerik */}
      <div className="main-content flex-grow-1 p-4 p-md-5">
        
        {/* Üst Kısım: Başlık ve Aksiyon Butonu */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h2 style={{ color: 'white', margin: 0 }}>Turnuva Yönetimi</h2>
            <span style={{ color: '#8b8b8b', fontSize: '14px' }}>Tüm aktif turnuvaları listeleyin ve yönetin.</span>
          </div>
          <Button variant="success" style={{ fontWeight: '600', backgroundColor: '#029220', border: 'none' }}>
            + Yeni Turnuva Ekle
          </Button>
        </div>
        
        {/* Liste Alanı */}
        {loading && page === 1 ? (
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
            <Spinner animation="border" variant="light" />
          </div>
        ) : (
          <div 
            style={{ 
              backgroundColor: '#121212', 
              borderRadius: '12px', 
              border: '1px solid #252525',
              overflow: 'hidden'
            }}
          >
            {/* Liste Başlıkları */}
            <div 
              className="d-flex align-items-center p-3" 
              style={{ 
                borderBottom: '1px solid #252525', 
                backgroundColor: '#0d0d0d',
                color: '#8b8b8b',
                fontSize: '13px',
                fontWeight: 'bold',
                textTransform: 'uppercase'
              }}
            >
              <div style={{ width: '60px' }}>Görsel</div>
              <div className="flex-grow-1 px-3">Turnuva Adı</div>
              <div style={{ width: '150px' }} className="text-center">Oynanma</div>
              <div style={{ width: '100px' }} className="text-end">İşlem</div>
            </div>

            {/* Liste İçeriği */}
            {data && data.length > 0 ? (
              <>
                {data.map((i, index) => (
                  <div 
                    key={`${i._id}-${index}`} 
                    className="d-flex align-items-center p-3 admin-list-row"
                    onClick={() => handleTournamentClick(i.slug)}
                    style={{ 
                      borderBottom: '1px solid #252525',
                      transition: 'background-color 0.2s ease',
                      cursor: 'pointer'
                    }}
                  >
                    {/* Görsel */}
                    <div style={{ width: '60px' }}>
                      <img 
                        src={i.image} 
                        alt={i.title} 
                        style={{ 
                          width: '50px', 
                          height: '50px', 
                          objectFit: 'cover', 
                          borderRadius: '8px' 
                        }} 
                      />
                    </div>
                    
                    {/* Başlık */}
                    <div className="flex-grow-1 px-3" style={{ color: 'white', fontWeight: '500', fontSize: '15px' }}>
                      {i.title}
                    </div>
                    
                    {/* Oynanma Sayısı */}
                    <div style={{ width: '150px', color: '#8b8b8b', fontSize: '14px' }} className="text-center">
                      <b style={{ color: '#029220' }}>{i.playCount}</b> kez
                    </div>
                    
                    {/* Buton */}
                    <div style={{ width: '100px' }} className="text-end">
                      <Button 
                        variant="outline-light" 
                        size="sm" 
                        style={{ borderRadius: '6px', fontSize: '12px' }}
                        onClick={(e) => {
                          e.stopPropagation(); 
                          handleTournamentClick(i.slug);
                        }}
                      >
                        Detay
                      </Button>
                    </div>
                  </div>
                ))}

                {/* Sonsuz Kaydırma (Infinite Scroll) Tetikleyicisi */}
                <div ref={lastElementRef} style={{ height: '20px' }}></div>
                
                {/* Aşağı Kaydırınca Çıkan Spinner */}
                {loadingMore && (
                  <div className="d-flex justify-content-center p-3">
                    <Spinner animation="border" variant="secondary" size="sm" />
                  </div>
                )}
              </>
            ) : (
              <div className="p-4 text-center" style={{ color: "#8b8b8b" }}>
                Gösterilecek aktif turnuva bulunmuyor.
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default AllTournaments;